//
// Baseline style for most components
//
import { black0 } from '@spotify-internal/encore-foundation';
import { css } from 'styled-components';
/* eslint-disable import/prefer-default-export */

export var rootStyle = function rootStyle() {
  return css(["box-sizing:border-box;font-family:spotify-circular,Helvetica,Arial,sans-serif;-webkit-tap-highlight-color:", ";"], black0);
};